import { useTranslation } from '@/lib/i18n'

/**
 * The red asterisk after the label of a datum the call is written from: the
 * residence saves without it, the call does not publish.
 */
function RequiredMark() {
	const { t } = useTranslation()
	return (
		<>
			<span aria-hidden className='text-destructive'>
				*
			</span>
			<span className='sr-only'>
				{t('admin-residences:form.required_for_call')}
			</span>
		</>
	)
}

export { RequiredMark }
